const dic = [
  {
    code: 'G_SIGN_DOCUMENT_E_FIRST_NAME',
    item_type: 'simple',
    field_name: 'first_name',
    submit_value_type: 'VALUE_TEXT',
    type: 'TEXT',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 1,
    max_text_length: null,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null,
    size: '50%'
  },
  {
    code: 'G_SIGN_DOCUMENT_E_LAST_NAME',
    item_type: 'simple',
    field_name: 'last_name',
    submit_value_type: 'VALUE_TEXT',
    type: 'TEXT',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 1,
    max_text_length: null,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null,
    size: '50%'
  },

  {
    code: 'G_SIGN_DOCUMENT_E_SIGNATORY_EMAIL_ADDRESSES',
    item_type: 'simple',
    field_name: 'signatory_email_addresses',
    submit_value_type: 'VALUE_TEXT',
    type: 'EMAIL',
    description: 'EMAIL_ADDRESS_OF_SIGNATORIES',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: null,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 1,
    max_text_length: null,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null
  },

  {
    code: 'G_SIGN_DOCUMENT_E_ATTACHMENT',
    item_type: 'simple',
    field_name: '',
    submit_value_type: 'VALUE_BINARY_FILE',
    type: 'FILE',
    description: 'UPLOAD_DOCUMENT_FOR_SIGNING',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: null,
    max_text_length: null,
    min_size_bytes: 1024,
    max_size_bytes: 8388608,
    required_bytes_mime_type: null
  },

  {
    code: 'G_SIGN_DOCUMENT_E_PHONE_NUMBER',
    item_type: 'simple',
    field_name: 'phone_number',
    submit_value_type: 'VALUE_TEXT',
    type: 'PHONE_NUMBER',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 6,
    max_text_length: null,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null,
    size: '50%'
  },

  {
    code: 'G_SIGN_DOCUMENT_E_COMMENT',
    item_type: 'simple',
    field_name: 'comment',
    submit_value_type: 'VALUE_TEXT',
    type: 'TEXT_MULTILINE',
    hint: null,
    readonly: false,
    min_number_of_submissions: 0,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 1,
    max_text_length: 300,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null
  },

  {
    code: 'G_SIGN_DOCUMENT_E_PERSONAL_NUMBER',
    item_type: 'simple',
    field_name: 'personal_number',
    submit_value_type: 'VALUE_TEXT',
    type: 'TEXT',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 10,
    max_text_length: 13,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null,
    size: '50%'
  },

  {
    code: 'G_SIGN_DOCUMENT_E_CITIZENSHIP',
    item_type: 'simple',
    field_name: 'citizenship_country_id',
    submit_value_type: 'VALUE_TEXT',
    type: 'LIST_DYNAMIC',
    hint: null,
    readonly: false,
    min_number_of_submissions: 1,
    max_number_of_submissions: 1,
    decimal_number: null,
    min_number_value: null,
    max_number_value: null,
    min_text_length: 2,
    max_text_length: 2,
    min_size_bytes: null,
    max_size_bytes: null,
    required_bytes_mime_type: null,
    options_directory: {
      name: 'country',
      id: 'id',
      label: 'name',
      value: 'id'
      // value: 'iso_3166_alpha_two_code'
    },
    size: '50%'
  }
];

export const getAdviseElement = (code) => {
  return dic.find(element => element.code === code);
};